import type { SvgIconComponent } from "@mui/icons-material";
import { TrendingDown, TrendingUp } from "@mui/icons-material";

export interface MetricCardProps {
  label: string;
  value: string;
  trend: string;
  icon: SvgIconComponent;
  negative?: boolean;
  style?: string
} 
function MetricCard({ label, value, trend, icon: Icon, negative = false, style }: MetricCardProps) {
  return (
    <article className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm text-left">
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-medium text-slate-500">{label}</p>
        <span className={`flex rounded-md p-2 ${style}`}>
          <Icon fontSize="small" />
        </span>
      </div>
      <p className="mt-2 text-2xl font-semibold text-slate-900">{value}</p>
      <p className={`mt-1 flex items-center gap-1 text-xs font-medium ${negative ? "text-red-500" : "text-emerald-600"}`}>
        {negative ? <TrendingDown fontSize="inherit" /> : <TrendingUp fontSize="inherit" />}
        {trend} <span className="font-normal text-slate-400">vs last month</span>
      </p>
    </article>
  );
}

export default MetricCard;
